// Lambda API Configuration
// This replaces direct OpenAI calls with secure Lambda endpoints

// Hardcoded Lambda API URL for production
const getLambdaApiUrl = () => {
  // Always use the hardcoded Lambda API Gateway URL
  return 'https://gcbisolpbg.execute-api.us-east-2.amazonaws.com/dev';
};

export const LAMBDA_API_BASE_URL = getLambdaApiUrl();

// Lambda API endpoints
export const LAMBDA_ENDPOINTS = {
  CHAT: `${LAMBDA_API_BASE_URL}/api/ai/chat`,
  MILESTONES: `${LAMBDA_API_BASE_URL}/api/ai/milestones`,
  ANALYTICS: `${LAMBDA_API_BASE_URL}/api/ai/analytics`
};

// Helper function to make authenticated Lambda API calls
export const callLambdaAPI = async (endpoint, data, authToken) => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`Lambda API error: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Lambda API call failed:', error);
    throw error;
  }
};

// AI Chat function using Lambda
export const sendChatMessageViaLambda = async (message, history = [], authToken) => {
  return await callLambdaAPI(LAMBDA_ENDPOINTS.CHAT, {
    message,
    history
  }, authToken);
};

// Enhanced Milestones function using Lambda
export const generateMilestonesViaLambda = async (goalData, userContext = {}, authToken) => {
  return await callLambdaAPI(LAMBDA_ENDPOINTS.MILESTONES, {
    goalData,
    userContext
  }, authToken);
};

// Analytics function using Lambda
export const getAnalyticsViaLambda = async (studentProfile, collegeName, authToken) => {
  return await callLambdaAPI(LAMBDA_ENDPOINTS.ANALYTICS, {
    studentProfile,
    collegeName,
    analysisType: 'admission_chance'
  }, authToken);
};

// Check if Lambda endpoints are available
export const isLambdaAvailable = () => {
  return !!LAMBDA_API_BASE_URL;
};

console.log('Lambda API Configuration:', {
  baseUrl: LAMBDA_API_BASE_URL,
  endpoints: LAMBDA_ENDPOINTS,
  isAvailable: isLambdaAvailable()
});
